<template>
  <div class="bg">
    <div class="mt10">
      <el-input
          clearable
          v-model.trim="queryName"
          size="small"
          class="mr20"
          style="width: 260px;"
          placeholder="请输入部门/成员名称"
      ></el-input>
      <el-button type="primary" size="small" @click="queryLeftData">
        查询</el-button
      >
    </div>
    <div class="mt20 flex">
      <div class="left-table">
        <div class="left-content">
          <el-scrollbar
              ref="scrollContainer"
              :vertical="false"
              wrap-style="height: 604px;"
          >
            <el-tree
                    empty-text="暂无部门"
                    v-if="queryName != ''"
                    :data="list"
                    :load="loadNode"
                    ref="tree"
                    show-checkbox
                    :filter-node-method="filterNode"
                    node-key="id"
                    :props="defaultProps"
                    @check-change="handleCheckChange"
                    @node-click="nodeClick"
                    default-expand-all
            >
            </el-tree>
            <div
                    v-if="queryName == ''"
            >
              <el-tree
                      empty-text="暂无部门"
                      :props="props"
                      :load="loadNode"
                      node-key="id"
                      ref="tree"
                      :filter-node-method="filterNode"
                      :check-strictly="true"
                      highlight-current
                      lazy
                      show-checkbox
                      @check-change="handleCheckChange"
                      @node-click="nodeClick"
              ></el-tree>
            </div>

          </el-scrollbar>
        </div>
      </div>
      <div class="right-table">
        <el-table
            :data="selectDataList"
            border
            stripe
            size="small"
            height="590"
            style="width: 100%">
          <el-table-column
              header-align="center"
              align="center"
              label="已选择的部门或成员">
            <el-table-column
                prop="name"
                label="名称"
                header-align="center"
                align="center"
            >
            </el-table-column>
            <el-table-column
                prop="操作"
                header-align="center"
                align="center"
                width="60"
                label="操作">
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-button size="small" type="text" @click="removeCheckChange(scope.row,scope.$index)"
                  >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      status:'',
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {
        keywords: ""
      },
      props: {
        label: "name",
        children: "children",
        isLeaf: "leaf"
      },
      queryName:'',
      selectDataList: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    };
  },
  created() {},
  mounted() {},
  methods: {

    async queryLeftData() {
      if(this.queryName == ''){
        return false;
      }
      let params = {
                      queryName:this.queryName
                    };
      console.log(params)
      const { result } = await this.$store.dispatch("getByQueryName", params);
      let list = [];
      result.forEach(v => {
        let item = {};
        for (const key in v) {
          item = {
            name: key,
            children: v[key]
          }
          list.push(item);
        }
        
      })
      console.log("list", list);
      this.list = list;

      //this.list = result;
    },
    //根据key查询数据
    filterNode(value, data) {
      console.log(data)
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    //删除选中
    removeCheckChange(row,index) {
      console.log(index);
      this.selectDataList.splice(index, 1);
      this.leftCheck();
    },
    //左边数据选中
    leftCheck() {
      this.$refs.tree.setCheckedNodes(this.selectDataList);
    },
    //成员选择
    handleCheckChange(data, checked, indeterminate) {
      console.log("data:" + data);
      console.log("checked:" + checked);
      let item = JSON.parse(JSON.stringify(data));
      console.log("item:" + item);

      if (checked) {
        if (!data.userid) {
          item.type = "department";
        } else {
          item.type = "employee"; 
        }
        // let re = {
        //   name:item.name,
        //   id:item.id
        // };
        // this.selectDataList.push(re);
        this.selectDataList.push(item);
        console.log("selectDataList", this.selectDataList)
      } else {
        console.log(item);
        this.selectDataList.forEach((v,i) =>{
          if(v.id == item.id){
            this.selectDataList.splice(i,1);
          }
        } )
      }

    },
    nodeClick() {},
    loadNode(node, resolve) {
      // 一级节点处理
      if (node.level === 0) {
        this.requestTree(resolve);
      }
      // 其余节点处理
      if (node.level >= 1) {
        // 注意！把resolve传到你自己的异步中去
        this.getIndex(node, resolve);
      }
    },
    // 首次加载一级节点数据函数
    async requestTree(resolve) {
      const { result } = await this.$store.dispatch("getStoreWechatDepartments");
      if (result == null) {
        resolve([]);
      } else {
        resolve(result);
      }
    },
    // 异步加载叶子节点数据函数
    async getIndex(node, resolve) {
      console.log("node", node);

      if (resolve == null) {
        resolve([]);
      } else {
        let params = {
          departmentId: node.data.id
        };
        const { result } = await this.$store.dispatch("getStoreWechatDepartmentEmployees", params);
        result.forEach(v => {
          v.id = v.userid;
          v.leaf = true
        });
        resolve(result);
        this.leftCheck();
      }
    },

  },
};
</script>

<style scoped lang="scss">
.bg {
  background-color: #ffffff;
  padding: 20px;
}
.left-table {
  width: 45%;
  .left-content {
    width: 95%;
    border: 1px solid rgba(221, 221, 221, 1);
  }
}
.right-table {
  width: 55%;
  .bt-ms {
    width: 98%;
    height: 44px;
    border: 1px solid #DDDDDD;
    border-bottom: none;
  }
}
</style>
